<template>
  <div class="mainCon">
    公告列表
  </div>
</template>

<script>
export default {
  name: 'noticeList',
  data:function(){
    return {
    }
  },
  mouted(){
   
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/noticePage/noticeList.vue